import { defaultDashboardSchema } from '../data/defaultSchema';
import { updateReportPlotArea } from './dragableFunctions';

interface populateFunctionProps {
  stateProps: any;
  reportSchema: any;
  populateState: boolean;
  setPopulateState: any;
}

export const getTableDataInSheetID = async ({
  reports,
  appID,
  analyticsSchema,
  handleTableData,
}: {
  reports: any[];
  appID: string;
  analyticsSchema: { [key: string]: any };
  handleTableData: Function;
}) => {
  let tableDataInSheetID: { [key: string]: any } = {};
  const setTableDataInSheetID = (newTableData: { [key: string]: any }) => {
    tableDataInSheetID = { ...tableDataInSheetID, ...newTableData };
    return tableDataInSheetID;
  };
  for (let index = 0; index < reports.length; index++) {
    const reportElem = reports[index];
    if (reportElem?.sheetID) {
      const handleTableProps = {
        selectedTable:
          analyticsSchema?.appSheets?.[reportElem.sheetID]?.defaultTable?.tableID || '',
        appID: appID,
        sheetID: reportElem.sheetID,
        tableDataInSheetID: tableDataInSheetID,
        setTableDataInSheetID: setTableDataInSheetID,
      };
      const tableDataRes = await handleTableData(handleTableProps);
      if (tableDataRes.skip) {
        console.log('table not found');
      }
    }
  }
  return tableDataInSheetID;
};
export const populateFunction = (props: populateFunctionProps) => {
  const { stateProps, reportSchema, populateState } = props;
  if (!populateState) return;

  const CheckUpdateAndUpdateFunction = (setFunction: any, data: any, defaultData: any) => {
    if (data) {
      setFunction(data);
    } else {
      setFunction(defaultData);
    }
  };
  const {
    setReportName,
    setReportDescription,
    setSendTo,
    setReportTimeFrame,
    setScheduledTime,
    setReportFilter,
  } = stateProps;

  const updateArray = [
    {
      setFunction: setReportName,
      data: reportSchema.name,
      defaultData: defaultDashboardSchema.reportName,
    },
    {
      setFunction: setReportDescription,
      data: reportSchema.desc,
      defaultData: defaultDashboardSchema.reportDesc,
    },
    {
      setFunction: setReportTimeFrame,
      data: reportSchema.reportTimeFrame,
      defaultData: defaultDashboardSchema.reportTimeFrame,
    },
    {
      setFunction: setScheduledTime,
      data: reportSchema.scheduledTime,
      defaultData: defaultDashboardSchema.scheduledTime,
    },
    {
      setFunction: setReportFilter,
      data: reportSchema.reportFilter,
      defaultData: defaultDashboardSchema.reportFilter,
    },
    {
      setFunction: setSendTo,
      data: reportSchema.sendTo,
      defaultData: defaultDashboardSchema.sendTo,
    },
  ];

  // populateState
  updateArray.forEach(({ setFunction, data, defaultData }) => {
    CheckUpdateAndUpdateFunction(setFunction, data, defaultData);
  });
  // setPopulateCount((currentCount: number) => currentCount + 1);
  // setPopulateState((preElem: boolean) => !preElem);
  return { skip: false };
};
interface tableHeadPopulateFunctionProps {
  stateProps: any;
  reportSchema: any;
  populateState: boolean;
  setPopulateState: Function;
  setIsPopulateComplete: Function;
}
export const tableHeadPopulateFunction = async (props: tableHeadPopulateFunctionProps) => {
  const { stateProps, reportSchema, populateState, setPopulateState, setIsPopulateComplete } =
    props;
  if (!populateState) return;

  const CheckUpdateAndUpdateFunction = (setFunction: any, data: any, defaultData: any) => {
    if (data) {
      setFunction(data);
    } else {
      setFunction(defaultData);
    }
  };

  const {
    setPopulateCount,
    setReports,
    handleTableData,
    setTableDataInSheetID,
    analyticsSchema,
    appID,
    chartsData,
    tableDataInSheetID,
    setReportAreaLoading,
  } = stateProps;
  const reportsData = await updateReportPlotArea({
    reports: reportSchema.reports ?? defaultDashboardSchema.reports,
    appID,
    analyticsSchema,
    handleTableData,
    chartsData,
    setTableDataInSheetID,
    tableDataInSheetID,
    reportTimeFrame: reportSchema.reportTimeFrame ?? defaultDashboardSchema.reportTimeFrame,
    reportFilter: reportSchema.reportFilter ?? defaultDashboardSchema.reportFilter,
  });

  const updateArray = [
    {
      setFunction: setReports,
      data: reportsData.skip ? defaultDashboardSchema.reports : reportsData.reports,
      defaultData: defaultDashboardSchema.reports,
    },
  ];

  // populateState
  updateArray.forEach(({ setFunction, data, defaultData }) => {
    CheckUpdateAndUpdateFunction(setFunction, data, defaultData);
  });
  setPopulateCount((currentCount: number) => currentCount + 1);
  setPopulateState((preElem: boolean) => !preElem);
  setReportAreaLoading((preElem: boolean) => !preElem);
  setIsPopulateComplete((preElem: boolean) => !preElem);
};
